export const Role = {
    Administrador: 'Administrador', //El que crea usuarios, etc
    AdministrativoFacturador: 'AdministrativoFacturador',
    Paciente: 'Paciente',
    Auditor: 'AuditorObraSocial',
    AdministrativoReintegros: 'AdministrativoReintegros',
    FacturadorIOMA: 'FacturadorIOMA',
    Estadista: 'Estadista',
    SinRol: 'SinRol',
    Autorizador: 'Autorizador',
    AuditorGeneral: 'Auditor',
}

export const RoleNumeros = {
    Administrador: '5', 
    AdministrativoFacturador: '0',
    Paciente: '2',
    Auditor: '6',
    AdministrativoReintegros: '1',
    FacturadorIOMA: '4',
    Estadista: '3',
    SinRol: '7',
    Autorizador: '8',
    AuditorGeneral:'10'
}